import { createAction } from 'redux-actions';
import * as actionTypes from './constants';

export const fetchWizardData =
  createAction(actionTypes.FETCH_CAMPAIGN_WIZARD_DATA_REQUEST);
export const fetchWizardDataSuccess =
  createAction(actionTypes.FETCH_CAMPAIGN_WIZARD_DATA_SUCCESS);
export const fetchWizardDataFailure =
  createAction(actionTypes.FETCH_CAMPAIGN_WIZARD_DATA_FAILURE);

export const fetchCampaigns = createAction(actionTypes.FETCH_CAMPAIGNS_REQUEST);
export const fetchCampaignsSuccess = createAction(actionTypes.FETCH_CAMPAIGNS_SUCCESS);
export const fetchCampaignsFailure = createAction(actionTypes.FETCH_CAMPAIGNS_FAILURE);

export const fetchCampaign = createAction(actionTypes.FETCH_CAMPAIGN_REQUEST);
export const fetchCampaignSuccess = createAction(actionTypes.FETCH_CAMPAIGN_SUCCESS);
export const fetchCampaignFailure = createAction(actionTypes.FETCH_CAMPAIGN_FAILURE);

export const addCampaign = createAction(actionTypes.ADD_CAMPAIGN_REQUEST);
export const addCampaignSuccess = createAction(actionTypes.ADD_CAMPAIGN_SUCCESS);
export const addCampaignFailure = createAction(actionTypes.ADD_CAMPAIGN_FAILURE);

export const updateCampaign = createAction(actionTypes.UPDATE_CAMPAIGN_REQUEST);
export const updateCampaignSuccess = createAction(actionTypes.UPDATE_CAMPAIGN_SUCCESS);
export const updateCampaignFailure = createAction(actionTypes.UPDATE_CAMPAIGN_FAILURE);

export const deleteCampaign = createAction(actionTypes.DELETE_CAMPAIGN_REQUEST);
export const deleteCampaignSuccess = createAction(actionTypes.DELETE_CAMPAIGN_SUCCESS);
export const deleteCampaignFailure = createAction(actionTypes.DELETE_CAMPAIGN_FAILURE);

export const resetCampaignData = createAction(actionTypes.RESET_CAMPAIGN_DATA);

export const fetchCampaignsFeed =
  createAction(actionTypes.FETCH_CAMPAIGNS_FEED_REQUEST);
export const fetchCampaignsFeedSuccess =
  createAction(actionTypes.FETCH_CAMPAIGNS_FEED_SUCCESS);
export const fetchCampaignsFeedFailure =
  createAction(actionTypes.FETCH_CAMPAIGNS_FEED_FAILURE);

export const openCampaignsSidepanel =
  createAction(actionTypes.OPEN_CAMPAIGNS_SIDEPANEL);
export const closeCampaignsSidepanel =
  createAction(actionTypes.CLOSE_CAMPAIGNS_SIDEPANEL);
